<script setup lang="ts">
import LocaleSelect from './LocaleSelect.vue'
</script>

<template>
  <div class="auth">
    <header class="top">
      <RouterLink to="/" class="brand">Creditify</RouterLink>
      <LocaleSelect />
    </header>
    <main class="body"><slot /></main>
  </div>
</template>

<style scoped>
.auth {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 16px;
  max-width: 960px;
  width: 100%;
  margin: 0 auto;
}
.brand {
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--fg);
}
.body {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 2rem 16px 4rem;
}
.body > :deep(*) {
  width: 100%;
  max-width: 420px;
}
</style>
